import { intl } from '@/intl'

export function validateIcon(
  value: uui.domain.ui.forms.GpsVehicleFormValues['gps']['icon'],
): string | undefined {
  const { icon, icons } = value
  if (!icon) {
    return intl.translate({
      id: 'vehicles.form.edit.generalSettings.validation.icon.notSet',
    })
  }
  if (!icons.includes(icon)) {
    return intl.translate({
      id: 'vehicles.form.edit.generalSettings.validation.icon.notInCollection',
    })
  }
}
